import kyNPM, { HTTPError } from 'ky'
import { toast } from 'react-toastify'
import { APIURL } from '../../config'

export const ky = kyNPM.create({
  prefixUrl: APIURL,
  credentials: 'include',
  headers: {
    'x-module-id': process.env.REACT_APP_MODULE_ID
  },
  hooks: {
    afterResponse: [
      async (request, options, response) => {
        const { showErrorToast = false, customErrorMessage, showSuccessToast = false, customSuccessMessage } = options ?? {}

        if (response.ok) {
          if (showSuccessToast) {
            toast.success(customSuccessMessage ?? 'Request successful')
          }
        } else {
          let message = `Request failed: ${response.status}`
          try {
            const { message: serverMessage } = await response.json()
            message = serverMessage || message
          } catch {
            // ignore JSON parse errors
          }

          if (customErrorMessage) message = customErrorMessage
          console.error('API error:', message)
          if (showErrorToast) {
            toast.warn(message)
          }
        }
      }
    ]
  }
})

/**
 * @param {unknown} error
 */
export const parseKyError = async (error) => {
  if (error instanceof HTTPError) {
    const errorBody = await error.response.json().catch(() => ({}))
    return {
      status: error.response.status,
      message: /** @type {string} */ (errorBody?.message) || error.message
    }
  }

  if (error instanceof Error) {
    return {
      status: 500,
      message: error.message || 'Unexpected error'
    }
  }

  return {
    status: 500,
    message: 'Unexpected error'
  }
}

/**
 * @typedef {Awaited<ReturnType<typeof parseKyError>>} KyError
 */
